// src/services/roadmapApi.ts

import { baseApi } from "./baseApi";

export const roadmapApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createOrUpdateRoadmap: build.mutation({
      query: (payload) => ({
        url: "/roadmaps",
        method: "POST",
        body: payload,
      }),
    }),
    getRoadmapByToken: build.query({
      query: (token) => `/roadmaps/token/${token}`,
    }),

    // NEW: add-whatsapp mutation
    addWhatsapp: build.mutation({
      query: (payload: {
        name?: string;
        email: string;
        whatsapp: string;
        source?: any;
      }) => ({
        url: "/roadmaps/add-whatsapp",
        method: "POST",
        body: payload,
      }),
    }),

    submitQuiz: build.mutation<
      { ok: boolean; link?: string; token?: string; result?: any },
      {
        skill: string;
        monthlyGoal: string;
        firstName?: string;
        email: string;
        whatsapp?: string;
        source?: any;
      }
    >({
      query: (payload) => ({
        url: "/quiz/submit",
        method: "POST",
        body: payload,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateOrUpdateRoadmapMutation,
  useGetRoadmapByTokenQuery,
  useAddWhatsappMutation,
  useSubmitQuizMutation,
} = roadmapApi;
